<template>
  <div>
    <instruction-form
      v-if="instructionVisible"
      :instruction-id="instructionId"
      :operation-ids="operationIds"
      :modal-visible="modalVisible"
      @close="closeInstructionForm"
      @createSuccess="instructionCreated"
    />
    <deal-form
      v-if="modalVisible"
      :deal-id="dealId"
      :is-read-only="isReadOnly"
      :modal-visible="modalVisible"
      @close-and-refresh="closeAndRefresh"
      @close="closeModal"
      @save-event="saveEvent"
      @create-new="closeAndOpenModalCreate"
      :market-id="marketId"
    />
    <div v-show="!modalVisible">
      <page-toolbar>
        <period-control
          @change="periodChange"
          :show-all-year-item="true"
          :show-all-period-item="true"
        >
        </period-control>
        <kendo-button icon="add" v-if="!isReadOnly" title="Create deal" @click="openModalCreate">
        </kendo-button>
      </page-toolbar>

      <kendo-grid
        height="calc(100vh - 170px)"
        ref="dealGrid"
        :editable="!isReadOnly && 'inline'"
        :dataSource="dataSource"
        :columns="columns"
        :pageable="true"
        :filterable="true"
        :sortable="true"
        :navigatable="true"
        :autoBind="false"
      ></kendo-grid>
    </div>
  </div>
</template>
<script>
import $ from '@/helpers/jquery-bridge'
import DealForm from '@/views/List/Deal/DealForm'
import {mapGetters} from 'vuex'
import {enableExportExcel} from '@/helpers/export-helper'
import {getDataItem} from '@/helpers/kendo-helpers'
import PageToolbar from '@/components/PageToolbar'
import PeriodControl from '@/components/PeriodControl'
import InstructionForm from '@/components/Clients/Heroux/InstructionForm'
import notification from '@/helpers/notification'
import security from '@/mixins/security'
import categoryColumns from '@/mixins/categoryColumns'

export default {
  name: 'DealView',
  mixins: [security, categoryColumns],
  components: {
    DealForm,
    PageToolbar,
    PeriodControl,
    InstructionForm,
  },
  mounted() {
    let grid = this.$refs.dealGrid.kendoWidget()
    grid.element.on('click', '.dealCodeLink', e => {
      const dataItem = getDataItem(e.target)
      this.modalVisible = true
      this.dealId = dataItem.dealId
    })

    grid.element.on('click', '.instructionHref', e => {
      const dataItem = getDataItem(e.target)
      this.instructionVisible = true
      this.instructionId = dataItem.instructionId
    })

    const vm = this
    grid.element.on('click', '#fxInstruction', () => {
      if (Object.keys(vm.checkedItems).length === 0) {
        notification('Select transactions first!', 'info')
      } else {
        vm.instructionId = -1
        vm.instructionVisible = true
      }
    })

    grid.element.on('click', '.checkAll', e => {
      const checked = e.target.checked
      if (Object.keys(vm.checkedItems).length === 0) {
        $('.checkAll').prop('checked', false)
        //notification.display('First select a trade', 'Warning')
        return false
      }

      if (checked) {
        grid.dataSource.view().forEach(el => {
          vm.checkedItems[el.operationId] = true
        })
        $('input.checkbox').prop('checked', true)
        return
      }

      e.target.checked = false
      vm.checkedItems = {}
      grid.dataSource.filter([])
    })

    grid.element.on('click', '.checkbox', e => {
      const dataItem = getDataItem(e.target)
      const checked = e.target.checked
      if (checked) {
        if (Object.keys(vm.checkedItems).length === 0) {
          let filters = vm.buildInstructionFilters(
            dataItem,
            ['sectorName', 'counterpartyCode', 'foreignCcy', 'baseCcy'],
            dataItem.maturityDate,
          )
          grid.dataSource.query({filter: filters}).then(() => {
            vm.checkIfAllSelected(grid)
          })
        }

        vm.checkedItems[dataItem.operationId] = true
        vm.checkIfAllSelected(grid)
      } else {
        delete vm.checkedItems[dataItem.OperationId]

        if (Object.keys(vm.checkedItems).length === 0) {
          grid.dataSource.filter([])
          $('.checkAll').prop('checked', false)
        }
      }
    })

    enableExportExcel(grid, '/api/heroux/HerouxTrade/exportToExcel', $('.page_toolbar-item'))
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({hasInstruction: 'app/hasInstruction'}),
    ...mapGetters({marketId: 'app/marketId'}),
    operationIds() {
      return Object.keys(this.checkedItems)
    },
    grid() {
      return this.$refs.dealGrid
    },
    columns() {
      return [
        {
          hidden: !this.hasInstruction,
          width: '55px',
          attributes: {style: 'text-align: center;'},
          headerTemplate: () => {
            if (this.isReadOnly) return ''
            let fxInstruction =
              "<button type='button' id='fxInstruction' title='FX Instruction' class='k-button k-button-icon' style='padding:0;margin-bottom:3px!important;width:22px;height:20px'>" +
              "   <i class='k-icon k-i-align-left'></i>" +
              '</button>'

            return (
              fxInstruction +
              '<input style="display:inline-block" type="checkbox" class="checkAll checkbox" />'
            )
          },
          template: dataItem => {
            if (dataItem.operationId === 0) {
              return ''
            }

            let template
            if (dataItem.instructionId === -1) {
              const checkedAttr = this.checkedItems[dataItem.operationId] ? 'checked="checked"' : ''
              template =
                '<input style="display: inline-block;" id="checkBoxId' +
                dataItem.operationId +
                '" type="checkbox" class="checkbox" ' +
                checkedAttr +
                ' />'
            } else {
              template = '<a class="instructionHref" href="javascript:;">T</a>'
            }
            return template
          },
          locked: true,
        },
        {
          field: 'dealId',
          title: 'Group Id',
          width: 90,
          attributes: {style: 'text-align: right;'},
          filterable: {
            ui: function(element) {
              element.kendoNumericTextBox({format: 'N0', decimals: 0, spinners: false})
            },
          },
          locked: true,
        },
        {
          field: 'dealCode',
          title: 'Trade Id',
          width: 100,
          attributes: {style: 'text-align: left;'},
          template: kendo.template('<a href="javascript:;" class="dealCodeLink">#=dealCode#</a>'),
          locked: true,
        },
        {
          field: 'clientName',
          title: 'Client',
          width: 90,
          attributes: {style: 'text-align: left;'},
          //hidden: hideClientColumn,
          hidden: true,
        },
        {
          field: 'sectorName',
          title: 'Sector',
          width: 90,
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'divisionName',
          title: 'Division',
          width: 150,
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'counterpartyCode',
          title: 'Counterparty',
          width: 150,
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'reference',
          title: 'Reference',
          width: 142,
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'operationDescription',
          title: 'Description',
          width: 350,
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'productCode',
          title: 'Product',
          width: 100,
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'legCode',
          title: 'Leg',
          width: 80,
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'tradeDate',
          title: 'Trade Date',
          width: 120,
          attributes: {style: 'text-align: right;'},
          format: '{0:yyyy-MM-dd}',
        },
        {
          field: 'startDate',
          title: 'Start Date',
          width: 120,
          attributes: {style: 'text-align: right;'},
          format: '{0:yyyy-MM-dd}',
        },
        {
          field: 'hedgeMonth',
          title: 'Hedge Month',
          width: 120,
          attributes: {style: 'text-align: right;'},
          format: '{0:yyyy-MM-dd}',
        },
        {
          field: 'maturityDate',
          title: 'Maturity Date',
          width: 140,
          attributes: {style: 'text-align: right;'},
          format: '{0:yyyy-MM-dd}',
        },
        {
          field: 'settlementDate',
          title: 'Settlement Date',
          width: 140,
          attributes: {style: 'text-align: right;'},
          format: '{0:yyyy-MM-dd}',
        },
        {
          field: 'buySell',
          title: 'Buy / Sell',
          width: 82,
          attributes: {style: 'text-align: left;'},
        },
        {
          title: 'Amount Ccy1',
          field: 'foreignAmount',
          width: 140,
          attributes: {style: 'text-align: right;'},
          format: '{0:n0}',
        },
        {
          field: 'foreignCcy',
          title: 'Ccy1',
          width: 75,
          attributes: {style: 'text-align: left;'},
        },
        {
          title: 'Hedge Rate',
          field: 'hedgeRate',
          width: 140,
          attributes: {style: 'text-align: right;'},
          format: '{0:n4}',
          filterable: {
            ui: function(element) {
              element.kendoNumericTextBox({
                decimals: 4,
                format: 'n4',
                spinners: false,
                step: 0,
              })
            },
          },
        },
        {
          field: 'sellBuy',
          title: 'Buy / Sell',
          width: 82,
          attributes: {style: 'text-align: left;'},
        },
        {
          title: 'Amount Ccy2',
          field: 'baseAmount',
          width: 140,
          attributes: {style: 'text-align: right;'},
          format: '{0:n0}',
        },
        {
          title: 'Ccy2',
          field: 'baseCcy',
          width: 75,
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'hedgeType',
          title: 'Hedge Type',
          width: 100,
          attributes: {style: 'text-align: left;'},
        },
        {
          title: 'Reference Rate',
          field: 'referenceRate',
          width: 140,
          attributes: {style: 'text-align: right;'},
          format: '{0:n4}',
          filterable: {
            ui: function(element) {
              element.kendoNumericTextBox({
                decimals: 4,
                format: 'n4',
                spinners: false,
                step: 0,
              })
            },
          },
        },
        {
          title: 'Forward Points',
          field: 'forwardPoints',
          width: 140,
          attributes: {style: 'text-align: right;'},
          format: '{0:n4}',
        },
        {
          field: 'gainLoss',
          title: 'Gain / Loss',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:n2}',
        },
        {
          field: 'economySpread',
          title: 'Savings FINMETRIX',
          width: 100,
          attributes: {style: 'text-align: right;'},
          format: '{0:n2}',
        },
        {
          field: 'exercised',
          title: 'Exercised',
          width: 100,
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'optionTypeName',
          title: 'Option Type',
          width: 110,
          attributes: {style: 'text-align: left;'},
        },
        {
          title: 'Other Barrier',
          field: 'collarRate',
          width: 140,
          attributes: {style: 'text-align: right;'},
          format: '{0:n4}',
          filterable: {
            ui: function(element) {
              element.kendoNumericTextBox({
                decimals: 4,
                format: 'n4',
                spinners: false,
                step: 0,
              })
            },
          },
        },
        {
          field: 'settlementMethodName',
          title: 'Settlement Method',
          width: 110,
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'settlementCcy',
          title: 'Settlement Ccy',
          width: 110,
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'statusName',
          title: 'Status',
          width: 100,
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'otherReference',
          title: 'Other Ref.',
          width: 142,
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'lastModified',
          title: 'Last Modified',
          width: 140,
          attributes: {style: 'text-align: right;'},
          format: '{0:yyyy-MM-dd HH:mm}',
        },
        {
          field: 'lastUser',
          title: 'Last User',
          width: 120,
          attributes: {style: 'text-align: left;'},
        },
        ...this.categoryColumns,
        {
          field: 'canDelete',
          title: '&nbsp;',
          width: 40,
          filterable: false,
          attributes: {style: 'text-align: center;'},
          template:
            "# if(canDelete) { # <a class='k-button k-button-icontext k-grid-delete' >" +
            "<span class='k-icon k-i-delete'></span>Delete</a> # } #",
          hidden: this.isReadOnly,
        },
      ]
    },
  },
  methods: {
    instructionCreated(e) {
      this.instructionId = e
    },
    checkIfAllSelected(grid) {
      // All checked, check checkall
      if (Object.keys(this.checkedItems).length === grid.dataSource.view().length) {
        $('.checkAll').prop('checked', true)
      }
    },
    buildFilters(dataItem, fields) {
      let filters = fields.map(function(el) {
        return {
          field: el,
          operator: 'eq',
          value: dataItem.get(el),
        }
      })
      return filters
    },
    makeDateFilter(date) {
      return [
        {
          logic: 'and',
          filters: [
            {field: 'maturityDate', operator: 'gt', value: date}, //after to
            {field: 'instructionId', operator: 'eq', value: -1},
          ],
        },
      ]
    },
    buildInstructionFilters(dataItem, fields, settlementDate) {
      let filters = this.buildFilters(dataItem, fields)
      let orFilters = this.makeDateFilter(settlementDate)

      orFilters.push({field: 'operationId', operator: 'eq', value: dataItem.operationId})

      filters.push({
        logic: 'or',
        filters: orFilters,
      })

      return filters
    },

    closeInstructionForm() {
      this.instructionVisible = false
      this.instructionId = null
      this.checkedItems = {}

      let grid = this.$refs.dealGrid.kendoWidget()
      grid.dataSource.filter([])
      $('.checkAll').prop('checked', false)
    },
    periodChange(e) {
      this.startDate = e.startDate
      this.endDate = e.endDate
      this.gridRefresh()
    },
    gridChange() {},
    openModalUpdate: function(e) {
      e.preventDefault()

      let grid = this.$refs.dealGrid.kendoWidget()
      var dataItem = grid.dataItem($(e.currentTarget).closest('tr'))
      this.modalVisible = true
      this.dealId = dataItem.dealId
    },
    closeAndOpenModalCreate() {
      this.closeModal()

      setTimeout(() => {
        this.openModalCreate()
      }, 500)
    },
    openModalCreate() {
      this.modalVisible = true
      this.dealId = 0
    },
    closeModal() {
      this.dealId = null
      this.modalVisible = false
      this.gridRefresh()
    },
    gridRefresh() {
      let grid = this.$refs.dealGrid.kendoWidget()
      grid.dataSource.read()
    },
    saveEvent(dealId) {
      this.dealId = dealId

      let grid = this.$refs.dealGrid.kendoWidget()
      grid.dataSource.read()
    },
    closeAndRefresh() {
      this.closeModal()
      this.refreshCategoryColumns().then(() => {
        this.gridRefresh()
      })
    },
  },
  data() {
    return {
      dealId: null,
      modalVisible: false,
      instructionId: null,
      instructionVisible: false,
      checkedItems: {},
      startDate: null,
      endDate: null,
      dataSource: {
        type: 'aspnetmvc-ajax',
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        pageSize: 20,
        transport: {
          read: {
            type: 'GET',
            url: '/api/heroux/HerouxTrade',
            data: () => ({
              startDate: this.startDate,
              endDate: this.endDate,
              clientId: this.clientId,
              marketId: this.marketId,
            }),
            dataType: 'json',
          },
          destroy: {
            type: 'DELETE',
            url: '/api/heroux/HerouxTrade',
            dataType: 'json',
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'dealId',
            fields: {
              dealId: {type: 'number'},
              ccyPairId: {type: 'number'},
              operationId: {type: 'number'},
              instructionId: {type: 'number'},
              dealCode: {type: 'string', field: 'dealCode', editable: false},
              reference: {type: 'string', field: 'reference', editable: false},
              otherReference: {type: 'string', field: 'otherReference', editable: false},
              clientName: {type: 'string', field: 'clientName', editable: false},
              statusName: {type: 'string', field: 'statusName', editable: false},
              sectorName: {type: 'string', field: 'sectorName', editable: false},
              counterpartyCode: {type: 'string', field: 'counterpartyCode', editable: false},
              divisionName: {type: 'string', field: 'divisionName', editable: false},
              productCode: {type: 'string', field: 'productCode', editable: false},
              buySell: {type: 'string'},
              baseAmount: {type: 'number', field: 'baseAmount'},
              baseCcy: {type: 'string', field: 'baseCcy'},
              tradeDate: {type: 'date'},
              startDate: {type: 'date'},
              hedgeMonth: {type: 'date'},
              maturityDate: {type: 'date'},
              settlementDate: {type: 'date'},
              foreignAmount: {type: 'number'},
              foreignCcy: {type: 'string'},
              hedgeRate: {type: 'number'},
              referenceRate: {type: 'number'},
              otherReferenceRate: {type: 'number'},
              collarRate: {type: 'number'},
              description: {type: 'string'},
              hedgeType: {type: 'string'},
              lastModified: {type: 'date'},
              lastUser: {type: 'string'},
              exercised: {type: 'string'},
              gainLoss: {type: 'number'},
              economySpread: {type: 'number'},
              optionTypeName: {type: 'string'},
              settlementMethodName: {type: 'string'},
              settlementCcy: {type: 'string'},
              canDelete: {type: 'bool', defaultValue: true, editable: false},
            },
          },
        },
      },
    }
  },
}
</script>
